module.exports = __webpack_public_path__ + "img/pelota-tenis-primer-plano.d7957c5b.jpg";